const FILE = "__file__";
const FOLDER = "__folder__";

const ADD_ENTRY = "__add_entry__";
const DELETE_ENTRY = "__delete_entry__";
const SET_ENTRY = "__set_entry__";

const ADD_RECYCLE_ENTRY = "__add_recycle_entry__";
const DELETE_RECYCLE_ENTRY = "__delete_recycle_entry__";
const SET_RECYCLE_ENTRY = "__set_recycle_entry__";

const SET_STORAGE_INFO = "__set_storage_info__";

const SET_ALL_DATA = "__set_all_data__"


const LOCAL = "__local__";
const GLOBAL = "__global__";

export { FILE, FOLDER, ADD_ENTRY, DELETE_ENTRY, LOCAL, GLOBAL, SET_ENTRY, ADD_RECYCLE_ENTRY, SET_RECYCLE_ENTRY, DELETE_RECYCLE_ENTRY, SET_STORAGE_INFO, SET_ALL_DATA };
